"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import NavLogo from "../../assets/NavLogo.png"
import "./Navbar.css"

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  // Added state for logout confirmation popup
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const checkAuthState = () => {
      const jwtToken = localStorage.getItem("jwtToken")
      const token = localStorage.getItem("token")
      const authToken = localStorage.getItem("authToken")
      const clientCode = localStorage.getItem("clientCode")
      const isSSO = localStorage.getItem("isSSO")

      const isOnLoginPage = window.location.pathname === "/" || window.location.pathname.includes("clientdetails")

      if (isOnLoginPage && !isSSO) {
      
        setIsLoggedIn(false)
        return
      }

      const isAuthenticated = !!(jwtToken || token || authToken || clientCode)
  
      setIsLoggedIn(isAuthenticated)
    }

    checkAuthState()

    const handleStorageChange = () => {
   
      checkAuthState()
    }

    const handleLocationChange = () => {
     
      setTimeout(checkAuthState, 100)
    }

    window.addEventListener("storage", handleStorageChange)
    window.addEventListener("authStateChanged", handleStorageChange)
    window.addEventListener("popstate", handleLocationChange)

    const interval = setInterval(checkAuthState, 5000)

    const handleVisibilityChange = () => {
      if (!document.hidden) {
       
        checkAuthState()
      }
    }

    const handleWindowFocus = () => {
     
      checkAuthState()
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)
    window.addEventListener("focus", handleWindowFocus)

    return () => {
      window.removeEventListener("storage", handleStorageChange)
      window.removeEventListener("authStateChanged", handleStorageChange)
      window.removeEventListener("popstate", handleLocationChange)
      document.removeEventListener("visibilitychange", handleVisibilityChange)
      window.removeEventListener("focus", handleWindowFocus)
      clearInterval(interval)
    }
  }, [])

  // Modified handleLogout to show confirmation popup first
  const handleLogoutClick = () => {
    setShowLogoutConfirm(true)
  }

  // Added confirmation handler for actual logout
  const confirmLogout = () => {
   
    setShowLogoutConfirm(false)
    setIsOpen(false)

    const tokensToRemove = [
      "jwtToken",
      "token",
      "authToken",
      "isSSO",
      "dpCode",
      "clientCode",
      "clientName",
      "isDpCodeFlow",
      "lastPaymentAmount",
    ]

    tokensToRemove.forEach((tokenKey) => {
      localStorage.removeItem(tokenKey)
    })

    setIsLoggedIn(false)

    window.dispatchEvent(new Event("authStateChanged"))
    window.dispatchEvent(new Event("storage"))
    navigate("/")
  }

  // Added cancel logout handler
  const cancelLogout = () => {
    setShowLogoutConfirm(false)
  }

  const navItems = [
    { text: "About Us", link: "https://www.arihantcapital.com/about-us" },
    { text: "Fund Transfer", link: "https://www.arihantcapital.com/fund-transfer" },
    { text: "Partner With Us", link: "https://www.arihantcapital.com/business-partner" },
    { text: "Support", link: "https://support.arihantcapital.com/support/home" },
  ]
  const highlightItem = "Open an Account"

  const toggleMenu = () => {
    setIsOpen((prevState) => !prevState)
  }

  return (
    <div className="navbar">
      <nav className="navbar-content">
        {/* Always show logo, improved mobile hamburger menu */}
        <img src={NavLogo || "/placeholder.svg"} alt="Logo" className="navbar-logo" />
        
        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          {isOpen ? (
            <div className="close-icon">
              <span className="close-line close-line-1"></span>
              <span className="close-line close-line-2"></span>
            </div>
          ) : (
            <div className="hamburger-icon">
              <span className="menu-line"></span>
              <span className="menu-line"></span>
              <span className="menu-line"></span>
            </div>
          )}
        </button>
        
        <div className={`nav-links ${isOpen ? "open" : ""}`}>
          {navItems.map((item, index) => (
            <a key={index} href={item.link} className={`nav-item ${item.text === highlightItem ? "highlight" : ""}`}>
              <div className="nav-text">{item.text}</div>
            </a>
          ))}
          <a
            href="https://ekyc.arihantcapital.com/"
            className={`nav-item ${highlightItem === "Open an Account" ? "highlight" : ""}`}
          >
            <div className="nav-text">Open an Account</div>
          </a>
          {isLoggedIn && (
            <button onClick={handleLogoutClick} className="logout-btn">
              <div className="nav-text">Logout</div>
            </button>
          )}
        </div>
      </nav>

      {/* Added logout confirmation popup */}
      {showLogoutConfirm && (
        <div className="logout-popup-overlay">
          <div className="logout-popup">
            <h3>Confirm Logout</h3>
            <p>Are you sure you want to logout?</p>
            <div className="logout-popup-buttons">
              <button onClick={confirmLogout} className="logout-confirm-btn">
                Yes
              </button>
              <button onClick={cancelLogout} className="logout-cancel-btn">
                No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Navbar
